/* eslint-disable max-len */
/**
 * Modal to show contact support info.
 * - variant 'cancellation': Used when blocking cancellation flow (heading/message for cancellation).
 * - variant 'general': Used for Contact us / general support (heading "For further support", same numbers).
 * For Flyin: Shows Flyin-specific contact details.
 * For Cleartrip: Shows Cleartrip contact details.
 */
import React from 'react'
import { isInFlyinDomain } from 'AccountsUtils'
import DesktopModalPWA from '../DesktopModal/DesktopModalPWA'
import { getMappedValue } from '../../utils/arabicUtils'

const CANCELLATION_BLOCK_HEADER = 'Cancellation support'
const GENERAL_SUPPORT_HEADER = 'For further support'
const CANCELLATION_INTRO = 'For cancellation please contact our customer support'
const GENERAL_SUPPORT_INTRO = 'For further support please contact our customer support'

const FlyinContactContent = ({ introMessage }) => (
  <div className="fs-13 c-neutral-700">
    <p className="mb-3">
      {introMessage}
    </p>
    <p className="mb-2">
      <span className="fw-600">
        {getMappedValue('For Calls From Saudi Arabia')}:
      </span>{' '}
      920025959
    </p>
    <p className="mb-2">
      <span className="fw-600">
        {getMappedValue('For International calls & Whatsapp')}:
      </span>{' '}
      +966920025959
    </p>
    <p className="mb-0">
      <span className="fw-600">
        {getMappedValue('For any general inquiries')}:
      </span>{' '}
      customercare@flyin.com
    </p>
  </div>
)

const CleartripContactContent = ({ introMessage }) => (
  <div className="fs-13 c-neutral-700">
    <p className="mb-3">
      {introMessage}
    </p>
    <p className="mb-2">
      <span className="fw-600">{getMappedValue('Customer Care No')}:</span> +971
      48754545
    </p>
    <p className="mb-2">
      <span className="fw-600">
        {getMappedValue('WhatsApp support number')}:
      </span>{' '}
      +971 502672234
    </p>
    <p className="mb-0">
      <span className="fw-600">
        {getMappedValue('For any general inquiries')}:
      </span>{' '}
      customersupport@cleartrip.ae
    </p>
  </div>
)

const CancellationBlockModal = ({ isOpen, onClose, isPWA, variant = 'cancellation' }) => {
  const ModalComponent = DesktopModalPWA
  const isGeneral = variant === 'general'
  const header = getMappedValue(isGeneral ? GENERAL_SUPPORT_HEADER : CANCELLATION_BLOCK_HEADER)
  const introMessage = getMappedValue(isGeneral ? GENERAL_SUPPORT_INTRO : CANCELLATION_INTRO)

  const content = isInFlyinDomain() ? (
    <FlyinContactContent introMessage={introMessage} />
  ) : (
    <CleartripContactContent introMessage={introMessage} />
  )

  const modalProps = {
    showFlag: isOpen,
    onCloseModal: onClose,
    header,
    content
  }
  if (isPWA) {
    modalProps.headerClassName = 'cancellation-block-modal-header'
    modalProps.closeIconClassName = 'cancellation-block-modal-close'
  }

  return <ModalComponent {...modalProps} />
}

export default CancellationBlockModal
